import { assertNever } from '@kofno/piper';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { observer } from 'mobx-react';
import { TPlainTextKey, translation, TranslationsContext } from '../../../../Translations';
import ParticipantsV2Store from '../Store';

type Direction = 'previous' | 'next';

interface Props {
  store: ParticipantsV2Store;
  direction: Direction;
  target: number;
  disabled: boolean;
}

const label = (direction: Direction): TPlainTextKey => {
  switch (direction) {
    case 'previous':
      return 'Previous page';
    case 'next':
      return 'Next page';
    default:
      return assertNever(direction);
  }
};

const Icon = ({ direction }: { direction: Direction }) => {
  switch (direction) {
    case 'previous':
      return <ChevronLeft className="h-4 w-4" aria-hidden="true" />;
    case 'next':
      return <ChevronRight className="h-4 w-4" aria-hidden="true" />;
    default:
      return assertNever(direction);
  }
};

const goToPage = (store: ParticipantsV2Store) => (page: number) => () => store.goToPage(page);

function StepButton({ store, direction, target, disabled }: Props) {
  return (
    <TranslationsContext.Consumer>
      {(ts) => (
        <button
          type="button"
          onClick={goToPage(store)(target)}
          disabled={disabled}
          aria-label={translation(label(direction))(ts)}
          className="flex items-center rounded-md p-1.5 text-foreground transition-colors hover:bg-muted focus:outline-none focus:ring-2 focus:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
          data-intercom-target={`people-v2-pagination-${direction}-button`}
        >
          <Icon direction={direction} />
        </button>
      )}
    </TranslationsContext.Consumer>
  );
}

export default observer(StepButton);
